"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var redux_form_1 = require("redux-form");
var GridFilterComponent_1 = __importDefault(require("./GridFilterComponent"));
var GridFilterForm = (0, redux_form_1.reduxForm)({
    enableReinitialize: true
    // @ts-ignore
})(GridFilterComponent_1["default"]);
exports["default"] = GridFilterForm;
